import PropTypes from 'prop-types';

import Button from '@zenbusiness/zui/Button';
import IconButton from '@zenbusiness/zui/IconButton';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

function ResponsiveButton({ children, icon, ...delegated }) {
  const { sizes } = useBreakpoints();
  const isMobile = !sizes.isDesktop;

  const sharedProps = {
    clickstreamProps: {
      elementName: 'app_header_action'
    },
    'data-testid': 'app-header-action',
    color: 'primary',
    size: 'sm',
    variant: 'contained',
    ...delegated
  };

  if (isMobile) {
    return <IconButton {...sharedProps} icon={icon} label={children} />;
  }

  return <Button {...sharedProps}>{children}</Button>;
}

ResponsiveButton.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.node
};

export default ResponsiveButton;
